export default __webpack_public_path__ + "static/media/ic_bsc.02a3f23f.svg";